var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "welfare-login" }, [
    _c("div", { staticClass: "girl" }),
    _c("div", { staticClass: "icon-discount" }),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "login-title" },
        [
          _vm.isShow
            ? _c("AutoFontSize", [
                _vm._v(_vm._s(_vm.$t("text_welfare_login_title"))),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("text_welfare_login_subtitle"))),
      ]),
      _c(
        "div",
        { staticClass: "award-wrap" },
        _vm._l(_vm.CONFIG, function (value, key) {
          return _c(
            "div",
            { key: key, staticClass: "award-item", class: { complete: value } },
            [
              _c("div", { staticClass: "top" }, [
                _c("div", { staticClass: "counpon" }, [
                  value ? _c("div", { staticClass: "mask" }) : _vm._e(),
                  _c("div", { staticClass: "discount" }, [_vm._v("10%")]),
                  _c("div", { staticClass: "txt" }, [
                    _vm._v(_vm._s(_vm.$t("coupon"))),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "bottom" }, [
                _vm._v(_vm._s(_vm.$t(`text_${key}`))),
              ]),
            ]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "btns" },
        _vm._l(_vm.CONFIG, function (value, key) {
          return _c("div", { key: key, staticClass: "btn-wrap" }, [
            value
              ? _c(
                  "div",
                  {
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        return _vm.$bus.$emit("welfare-events", "toStore")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("text_use_now")))]
                )
              : _vm._e(),
          ])
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "rules" }, [
      _vm._v("* " + _vm._s(_vm.$t("text_welfare_rule_1"))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }